module.exports = __webpack_public_path__ + "galleries-showcase-duo.jpg?a4b7143c205870032feec2d277d29c65";


//////////////////
// WEBPACK FOOTER
// ./src/images/galleries-showcase-duo.jpg
// module id = 380
// module chunks = 0